<script setup lang="ts">
import type { CharacteristicCardProps } from '.';

import TextLink from '~/components/ui/text-link/TextLink.vue';

defineProps<CharacteristicCardProps>();
</script>

<template>
	<div
		class="flex h-[54px] gap-3 rounded-sm bg-white-dark-1 lg:h-[65px]"
		:class="[
			title
				? 'items-start p-2 lg:px-4 lg:py-2'
				: 'items-center px-2 py-3 lg:p-4'
		]"
	>
		<div
			class="flex size-5 shrink-0 justify-center"
			:class="title ? 'items-start' : 'items-center'"
		>
			<slot name="icon" />
		</div>
		<div class="flex flex-col items-start lg:gap-0.5">
			<p
				v-if="title"
				class="font-sans text-xs font-normal leading-[150%] text-primary-light-3 lg:text-sm"
			>
				{{ title }}
			</p>
			<NuxtLink
				v-if="isLink && linkTo"
				:to="linkTo"
				class="font-sans text-sm font-medium leading-5 text-primary lg:text-base"
			>
				<TextLink variant="default">
					{{ value }}
				</TextLink>
			</NuxtLink>
			<span v-else class="font-sans text-sm font-medium leading-5 text-primary">
				{{ value }}
			</span>
		</div>
	</div>
</template>
